import { ApiInstance } from "@/libs/api-manager";
import { IAppVersionFlag } from "@/types/appVersionFlag";
import { IPaginationRequest, IPaginationResponse } from "../types";

export const fetchAppVersionFlags = async (payload: IPaginationRequest) => {
  const { data } = await ApiInstance.get<IPaginationResponse<IAppVersionFlag>>(
    "/api/vpn/app_version_flags",
    {
      params: payload,
    }
  );

  return data;
};
